module.exports = ".preview-note {\n    position: absolute;\n    top: 0;\n    left: 0;\n    padding: 6px 16px;\n    background-color: #f5f5f5;\n    width: 100%;\n    border-bottom: solid 1px #eee;\n    font-size: 0.9em;\n}\n\n.preview-body {\n    margin-top: 24px;\n    width: 100%;\n    height: 100%;\n}\n\n.ql-placeholder-content {\n    background-color: #cce8ff !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/template/preview/preview.component.css
// module id = ./src/app/common/template/preview/preview.component.css
// module chunks = main